import React from 'react';
import PropTypes from 'prop-types';

import buttonStyles from '../styles/styles.module.scss';

const SubmitButton = ({ text, handler, variant }) => {
  const onKeyPress = event => {
    if (event.key === 'Enter') {
      handler();
    }
  };

  return (
    <div className={buttonStyles[variant]} onKeyPress={onKeyPress} onClick={handler} tabIndex="0" role="button">
      {text}
    </div>
  );
};

SubmitButton.defaultProps = {
  text: 'submit',
  handler: () => {},
  variant: 'submit'
};

SubmitButton.propTypes = {
  text: PropTypes.string,
  handler: PropTypes.func,
  variant: PropTypes.string
};

export default SubmitButton;
